module.exports = __webpack_public_path__ + "static/img/Capricorn.a63343c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/zodiac_image/Capricorn.svg
// module id = 1397
// module chunks = 0